<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch, nextTick } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  slider: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  idslider: null,
  files: [],
});

function handleFileChange(e) {
  form.files = Array.from(e.target.files);
}
const fileInput = ref(null);
watch(
  () => props.slider,
  (newSlider) => {
    if (newSlider) {
      form.id = newSlider.id;
      form.idslider = newSlider.idslider;
      form.files = []; // Reset files array
      nextTick(() => {
        if (fileInput.value) fileInput.value.value = "";
      });
    }
  },
  { immediate: true, deep: true }
);

const closeModal = () => {
  emit("update:isOpen", false);
};

const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.post(route("sliders.updatefile", form.idslider), {
    onSuccess: () => {
      form.reset();
      // Reset input file di DOM
      if (fileInput.value) fileInput.value.value = "";
      closeModal();
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black/50"
    @click="handleClickOutside"
  >
    <div
      class="relative w-full max-w-lg h-auto max-h-[90dvh] p-4 overflow-y-auto bg-white rounded-xl shadow-lg sm:p-8"
    >
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }} {{ slider.judul }}</h2>
        <button
          type="button"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div
        v-if="(!form.files || !form.files.length) && slider.gambar"
        class="mb-4"
      >
        <div
          class="relative flex items-center justify-center w-full overflow-hidden bg-gray-100 border rounded"
          style="aspect-ratio: 16/9"
        >
          <img
            :src="
              typeof slider.gambar === 'string'
                ? slider.gambar
                : slider.gambar?.url || ''
            "
            alt="Gambar lama"
            class="object-cover w-full h-full rounded"
          />
        </div>
      </div>
      <div v-if="form.files && form.files.length" class="mb-4">
        <div
          v-for="(file, idx) in form.files"
          :key="idx"
          class="relative flex items-center justify-center w-24 h-24 overflow-hidden bg-gray-100 border rounded"
        >
          <img
            :src="URL.createObjectURL(file)"
            alt="Preview"
            class="object-cover w-full h-full"
          />
        </div>
      </div>
      <p class="mb-4 text-sm text-gray-600">
        Unggah file gambar untuk slider "{{ slider.judul }}".
      </p>
      <form class="space-y-6" @submit.prevent="submit">
        <div>
          <InputLabel
            for="gambar"
            value="File"
            class="block text-sm font-medium text-gray-700"
          />
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            @change="handleFileChange"
            class="block w-full mt-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:ring-indigo-500 focus:border-indigo-500"
          />
          <progress
            v-if="form.progress"
            :value="form.progress.percentage"
            max="100"
            class="w-full mt-2"
          >
            {{ form.progress.percentage }}%
          </progress>
          <InputError :message="form.errors.files" class="mt-2" />
        </div>
        <div class="mt-4">
          <PrimaryBtn :disabled="form.processing">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
